import { useTranslation } from "react-i18next";
import { ChatStore } from "@/stores/ChatStore";
import { validateRequired, validateFormat } from "@/lib/validation";

export const useDateOfBirthInput = () => {
  const { t } = useTranslation();
  const user = ChatStore(state => state.user);
  const setUser = ChatStore(state => state.setUser);
  const errors = ChatStore(state => state.userInfoFormErrors);
  const setError = ChatStore(state => state.setUserInfoFormError);

  const handleRequiredValidation = (value: string) => {
    const error = validateRequired("dateOfBirth", value, t);
    setError("dateOfBirth", error);
  };

  const handleFormatValidation = (value: string) => {
    const requiredError = validateRequired("dateOfBirth", value, t);
    if (!requiredError) {
      const formatError = validateFormat("dateOfBirth", value, t);
      setError("dateOfBirth", formatError);
    }
  };
  const handleChange = (value: string) => {
    if (user) {
      setUser({ ...user, dateOfBirth: value });
    }
    handleRequiredValidation(value);
  };

  const handleBlur = (value: string) => {
    handleFormatValidation(value);
  };

  return {
    user,
    errors,
    t,
    handleChange,
    handleBlur
  };
};
